import { Button, SvgIcon } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast from "react-hot-toast";
import SearchIcon from "@mui/icons-material/Search";
import { IconFlagCA, IconFlagIN, IconFlagUS } from "material-ui-flags";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import {
  getDateTime,
  investmentAdvicePath,
  searchFilter,
  handleSort,
  investmentDetailsPath,
} from "../utils/varialbles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchBar from "material-ui-search-bar";
import { ReactComponent as INLogo } from "../images/inflag.svg";

const getFlags = (country) => {
  let CountryMapper = {
    India: (
      <SvgIcon>
        <INLogo />
      </SvgIcon>
    ),
    USA: IconFlagUS,
    Canada: IconFlagCA,
  };
  if (country && CountryMapper[country] && country !== "India") {
    return React.createElement(CountryMapper[country]);
  } else {
    return CountryMapper["India"];
  }
};

const getCurrency = (name) => {
  let currencyMapper = {
    INR: "₹",
    USD: "$",
    CAD: "C$",
  };
  if (name && currencyMapper[name]) {
    return currencyMapper[name];
  } else {
    return currencyMapper["INR"];
  }
};
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 5,
    marginBottom: 60,
  },
  button: {
    borderRadus: 10,
  },
  detailsButton: {
    backgroundColor: "#fff",
    color: "#3c52b2",
    "&:hover": {
      backgroundColor: "#3c52b2",
      color: "#fff",
    },
    borderColor: "#3c52b2",
  },
}));
const columnsRequest = [
  { id: "userID", label: "User ID", minWidth: 150, align: "left", type: "id" },
  {
    id: "Investment_Amount",
    label: "Investment Country and Amount",
    minWidth: 150,
    align: "left",
  },
  { id: "Asset_Class", label: "Asset Class", minWidth: 150 },
  { id: "Investment_Name", label: "Investment Name", minWidth: 150 },
  {
    id: "Purchase_Quantity",
    label: "Purchase quantity",
    minWidth: 150,
    align: "center",
  },
  {
    id: "Purchase_Date",
    label: "Purchase Date",
    minWidth: 150,
    format: "Date",
  },
  {
    id: "Status_Auction_savartopinion",
    label: "Response status",
    minWidth: 150,
  },
  { id: "Status_Auction_reason", label: "Recommended Action", minWidth: 150 },
  // { id: 'RRStopDate', label: 'Current Status', minWidth: 150 },
  { id: "serve", label: "Served/ Unserved", minWidth: 150, type: "serve" },
];
function InvReviewTabs({ props, id }) {
  const [columns, setColumns] = useState([]);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const location = useLocation();
  const myparam = location.state;
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    // (searchedVal)
    setSearched(searchedVal);
    setPage(0);
  };
  const requestSearching = () => {
    if (searched === undefined || searched.length < 4) {
      toast.error("Please Enter more than 3 characters to search");
    } else {
      getData(searched);
    }
  };
  const cancelSearch = (searchVal) => {
    setSearched(searchVal);
    let abc = "";
    getData(abc);
  };
  const [investmenRequest, setInvestmenRequest] = useState(true);
  const [investmenReview, setInvestmenReview] = useState(false);
  let history = useHistory();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [totalRowCount, setTotalRowCount] = React.useState(0);
  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };
  const getData = (newQuery) => {
    toast.loading("Please wait...");

    setColumns(columnsRequest);
    let baseURL =
      props && props.customer_id
        ? "/invreviewrequest/" + props.customer_id
        : "/overalinvreviewrequest";

    http
      .get(getPaginationURL(baseURL, newQuery))
      .then((response) => {
        toast.dismiss();

        if (
          response &&
          response.data &&
          response.data.Investment_Review &&
          Array.isArray(response.data.Investment_Review) &&
          response.data.Investment_Review.length > 0
        ) {
          let newData = response.data.Investment_Review;
          let group = newData.reduce((r, a) => {
            r[a.Request_ID] = [...(r[a.Request_ID] || []), a];
            return r;
          }, {});
          let finalValues = Object.values(group);
          setRows(finalValues);
          setOriginalRows(finalValues);
          setTotalRowCount(response.data.totalRowCount);
        } else {
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      })
      .catch((error) => {
        console.log("error");
      });
  };

  useEffect(() => {
    getData();
    if (myparam && myparam.page) {
      setPage(myparam.page);
      delete myparam.page;
    }
  }, [page, rowsPerPage]);
  const viewInvesterDetails = (object) => {
    object.page = page;

    history.push({
      pathname: investmentAdvicePath,
      state: object,
    });
  };

  const viewInvestmentDetails = (object) => {
    history.push({
      pathname: investmentDetailsPath,
      state: myparam,
    });
  };

  console.log("Savart is Successful");
  return (
    <div className={classes.root}>
      {/* <Button
        variant="outlined"
        color="default"
        startIcon={<ArrowBackIosIcon />}
        onClick={viewInvestmentDetails}
      >
        Back
      </Button> */}

      <Paper className={classes.root}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={(searchVal) => cancelSearch(searchVal)}
              // style={{ height: "auto", padding: "5px 0", marginBottom: 20 }}
              // className={"mt30"}
              // style={{border:'3px solid blue', width:'10rem'}}
            />
            <Button
              variant="outlined"
              color="primary"
              style={{ marginLeft: "10px", borderRadius: "20px" }}
              onClick={requestSearching}
              onRequestSearch={requestSearching}
              disabled={!searched}
            >
              Search
            </Button>
          </div>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 500, 1500]}
            component="div"
            count={totalRowCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    // style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                    {/* <TableSortLabel
                                            active={orderBy === column.id}
                                            direction={orderBy === column.id ? order : 'asc'}
                                            onClick={e => handleRequestSort(e, column.id, column.format)}
                                        >
                                            {column.label}
                                        </TableSortLabel> */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows.map((row, index) => {
                    return row.map((subRow, subIndex) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={subIndex + "a"}
                          style={
                            row.length > 1 ? { backgroundColor: "#F2F4F9" } : {}
                          }
                        >
                          {columns.map((column, index) => {
                            const value =
                              subIndex === 0 &&
                              (column.id === "Creation_Date" ||
                                column.id === "userID")
                                ? subRow[column.id]
                                : subIndex > 0 &&
                                  (column.id === "Creation_Date" ||
                                    column.id === "userID")
                                ? ""
                                : subRow[column.id];
                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                                style={
                                  row.length > 1 && subIndex !== row.length - 1
                                    ? { borderBottom: "none" }
                                    : {}
                                }
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.format === "Date" && value !== "" ? (
                                  getDateTime(value)
                                ) : column.format === "boolean" &&
                                  subRow[column.id] ? (
                                  "Active"
                                ) : column.format === "boolean" &&
                                  !subRow[column.id] ? (
                                  "Inactive"
                                ) : column.id === "detailsButton" &&
                                  subIndex === Math.floor(row.length / 2) ? (
                                  <Button
                                    variant="outlined"
                                    className={classes.detailsButton}
                                    style={{ borderRadius: 10 }}
                                    onClick={() => viewInvesterDetails(subRow)}
                                    noWrap
                                  >
                                    View Advice
                                  </Button>
                                ) : column.id === "Investment_Amount" ? (
                                  <>
                                    <span>
                                      {getFlags(
                                        subRow["Country"][0]["locname"]
                                      )}
                                    </span>
                                    <span
                                      style={{
                                        position: "relative",
                                        top: "-5px",
                                        paddingLeft: 15,
                                      }}
                                    >
                                      {getCurrency(
                                        subRow["Country"][0]["currency"]
                                      ) +
                                        " " +
                                        value}
                                    </span>
                                  </>
                                ) : column.id ===
                                  "Status_Auction_savartopinion" ? (
                                  subRow["Status_Auction"] &&
                                  Array.isArray(subRow["Status_Auction"]) &&
                                  subRow["Status_Auction"].length > 0 ? (
                                    subRow["Status_Auction"][0]["savartopinion"]
                                  ) : (
                                    "N/A"
                                  )
                                ) : column.id === "Status_Auction_reason" &&
                                  subRow["Status_Auction"] &&
                                  Array.isArray(subRow["Status_Auction"]) ? (
                                  subRow["Status_Auction"].length > 0 ? (
                                    subRow["Status_Auction"][0]["reason"] ? (
                                      subRow["Status_Auction"][0]["reason"]
                                    ) : (
                                      "N/A"
                                    )
                                  ) : (
                                    "N/A"
                                  )
                                ) : column.type === "id" ? (
                                  id ? (
                                    id
                                  ) : (
                                    value
                                  )
                                ) : (
                                  (column.type = "serve"
                                    ? value && value.toString()
                                    : value
                                    ? value
                                    : "N/A")
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    });
                  })}
                </>
              ) : (
                <TableCell
                  colspan="7"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  Records Not Available
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
export default InvReviewTabs;
